import Nullstack from 'nullstack';
export default function IconIdBadge2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-id-badge-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 12h3v4h-3z"
  }), "   ", Nullstack.element("path", {
    d: "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "3",
    width: "4",
    height: "5",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M14 16h2"
  }), "   ", Nullstack.element("path", {
    d: "M14 12h4"
  }), " ");
}